import { render } from "./MaterialLightbox.vue?vue&type=template&id=435f26f7"
import script from "./MaterialLightbox.vue?vue&type=script&lang=js"
export * from "./MaterialLightbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/gradbeni-dnevnik/gradbeni-dnevnik/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__